import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {Header, Divider, Image} from 'semantic-ui-react';
import ItemsPanel from './ItemsPanel';
import Totals from './Totals';
import config from 'config';

class InfoPanel extends React.Component {
  state = {noLogo: false};

  render() {
    return (
      <div>
        <div style={{float: 'left'}}>
          {this.props.logoFilename && !this.state.noLogo ? (
            <Image
              alt="logo"
              onError={i => {
                i.target.style.display = 'none';
                this.setState({noLogo: true});
              }}
              src={`${config.baseUrl}/Portals/${this.props.portalId}/${
                this.props.logoFilename
              }`}
            />
          ) : (
            <Header as="h2" textAlign="left">
              {this.props.portalName}
            </Header>
          )}
        </div>

        <div style={{float: 'right'}}>
          <Header as="h5" textAlign="right">
            {this.props.portalPhone}
          </Header>
          <Header as="h5" style={{marginTop: 5}} textAlign="right">
            {this.props.portalEmail}
          </Header>
        </div>

        <div style={{clear: 'both'}} />

        <Header as="h3" textAlign="left">
          {this.props.invoice
            ? `Invoice #${this.props.invoice.invoiceNumber}`
            : this.props.estimate
              ? `Estimate #${this.props.estimate.estimateNumber}`
              : null}
        </Header>

        <Divider />

        <ItemsPanel
          isEstimate={!!this.props.estimate}
          items={
            this.props.invoice
              ? this.props.invoice.items
              : this.props.estimate
                ? this.props.estimate.items
                : null
          }
        />

        <Totals item={this.props.invoice || this.props.estimate} />
      </div>
    );
  }
}

InfoPanel.defaultProps = {
  estimate: null,
  invoice: null,
  logoFilename: null,
  portalPhone: null,
};

InfoPanel.propTypes = {
  // estimate or invoice item from parent
  estimate: PropTypes.shape({}),
  invoice: PropTypes.shape({}),

  // from redux
  portalId: PropTypes.string.isRequired,
  portalName: PropTypes.string.isRequired,
  logoFilename: PropTypes.string,
  portalPhone: PropTypes.string,
};

const mapStateToProps = state => {
  const logoFilename = state.portal.portalSettings.LogoFileName;
  const {portalInfo} = state.portal;

  return {
    logoFilename: logoFilename ? logoFilename.value : null,
    portalEmail: portalInfo.email,
    portalId: state.user.tokenData.portal_id,
    portalPhone:
      portalInfo.primaryPhone &&
      portalInfo.primaryPhone.toLowerCase() !== 'unknown'
        ? portalInfo.primaryPhone
        : null,
    portalName: state.portal.portalInfo.name,
  };
};

export default connect(mapStateToProps)(InfoPanel);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/InfoPanel.js